import UAParser from 'ua-parser-js';

export const isDesktop = (ua = window.navigator.userAgent) => {
  const parser = new UAParser(ua);

  return parser.getDevice().type === undefined;
};

export const isChrome = (ua = window.navigator.userAgent) => {
  const parser = new UAParser(ua);

  return parser.getBrowser().name === 'Chrome';
};

export const isVersion = (ua = window.navigator.userAgent) => {
  const parser = new UAParser(ua);

  return parseInt(parser.getBrowser().version, 10) >= 65;
};

export default function(ua = window.navigator.userAgent) {
  return isDesktop(ua) && isChrome(ua) && isVersion(ua);
}



// WEBPACK FOOTER //
// ./src/utils/isSupported.js